import React from 'react'
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import DateRangeFilter from './DateRangeFilter';
import PeriodFilter from './PeriodFilter';
import { DateRangeAndPeriodSelectionProps } from '../../types/types';
import { useSelector } from 'react-redux';
import store from '../../../../stateManagement/store';
import { TranslationEnum, usePortalTranslation } from '../../../../providers/TranslationProvider';

const DateRangeAndPeriodSelection = (props: DateRangeAndPeriodSelectionProps) => {
    const { translate } = usePortalTranslation();
    const koFilter = useSelector(() => Boolean(store.getState()?.fileFormat?.config?.useBusinessCalendar));
    return (
        <div className=''>
            <TabContext value={props.tabValue}>
                <Box sx={{ borderColor: "divider" }}>
                    <TabList
                    onChange={(event,value) => { props.setTabValue(value)}}
                    aria-label="lab API tabs example"
                    variant="fullWidth"
                    >
                    <Tab label={translate(TranslationEnum.reports,"Date Range")} value="1" />
                    <Tab label={translate(TranslationEnum.reports,koFilter? "KO" : "Period" + " Filter")} value="2" />
                    </TabList>
                </Box>
                <TabPanel value="1">
                    <DateRangeFilter minDate={props.minDate} startDate={props.startDate} endDate={props.endDate} setStartDate={props.setStartDate} setEndDate={props.setEndDate} />
                </TabPanel>
                <TabPanel value="2">
                    <PeriodFilter yearOptions={props.yearOptions} year={props.year} period={props.period} setPeriod={props.setPeriod} handleChangeYear={props.handleChangeYear} periodOptions={props.periodOptions} />
                </TabPanel>
                </TabContext>
        </div>
    )
}

export default DateRangeAndPeriodSelection